import { Box, Button, Stack, Typography } from '@mui/material'
import { IssueType } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { IIssueItem } from '../../Stores/IssueItem'
import { IssueStatusChip } from './IssueStatusChip'

interface Props {
  issueItem: IIssueItem
  onResolve: () => void
}
export const IssueCardHeader = observer(({ issueItem, onResolve }: Props) => {
  const { t } = useTranslate()
  const issue = issueItem.data

  return (
    <Box sx={{ padding: '1rem', display: 'flex' }}>
      <Stack
        direction='row'
        spacing={1}
        alignItems='center'
        justifyContent='space-between'
        width='100%'
      >
        <Typography variant='h4'>
          {t(issueItem.issueTitle)}
          {issueItem.data.issueType === IssueType.UnknownCompany &&
            `: ${issueItem.data.companyName}`}
        </Typography>
        <Stack direction='row' spacing={1} alignItems='center'>
          <IssueStatusChip status={issue.issueStatus} />
          <Button size='medium' variant='contained' onClick={() => onResolve()}>
            {t('resolve', 'Resolve')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
})
